module.exports = __webpack_public_path__ + "media/entrega_encomenda_para_cliente.e79185c0.mp4";